


let _ = require('../_.js');
let $ = jQuery;

_.User_Profile_Modal = class User_Profile_Modal {

    static init() {
        _.on_ui_update_once('#user-profile-modal-update-profile-btn', function () {
            $(this).click(async function () {
                _.User_Profile_Modal.show_edit_modal();
            });
        });

        _.on_ui_update_once('.ac-btn-back-to-user-settings', function () {
            $(this).click(async function () {
                _.Modal.hide();
                _.User_Profile_Modal.show_settings_modal();
            });
        });

        _.on_ui_update_once('#user-profile-edit-submit', function () {
            $(this).click(async function (e) {
                e.preventDefault();
                _.User_Profile_Modal.try_save_user_settings();
            });
        });

        _.on_ui_update_once('#user-profile-modal-change-password-btn', function () {
            $(this).click(async function () {
                _.User_Profile_Modal.change_user_password();
            });
        });

    }

    static show_settings_modal() {
        if (!_.ac_state.registrant) return;

        let registrant = _.ac_state.registrant;

        $("#user-profile-modal-name").text(_.full_name(registrant));
        $("#user-profile-modal-address-line1").text(registrant.address);
        $("#user-profile-modal-address-line2").text((registrant.city != '' ? registrant.city + ", " : "") + registrant.state + " " + registrant.zip);
        $("#user-profile-modal-phone").text(_.formatPhoneNumber(registrant.phone_number));
        $("#user-profile-modal-email").text(registrant.email);
        $("#user-profile-modal-account-created").text(new _.TimeManager(registrant.created_at).human_date());
        $("#user-profile-modal-bio").text(registrant.personal_bio);
        $("#user-profile-modal-sms-notifications").text(registrant.receive_sms ? "Yes" : "No");
        $("#user-profile-modal-email-notifications").text(registrant.receive_email ? "Yes" : "No");
        $("#user-profile-modal-contact-preference").text(registrant.user_contact_preference_label);

        $("#ac-modal-user-profile").modal_show();
    }

    static show_edit_modal() {

        let registrant = _.ac_state.registrant;
        if (!registrant) return;  // Check if the registrant data is available

        // Populate the input fields
        $("#user-profile-name").val(_.full_name(registrant));
        $("#user-profile-address").val(registrant.address);
        $("#user-profile-city").val(registrant.city);
        $("#user-profile-state").empty();
        for (let i in _.states) {
            let option = $('<option value="' + i + '">' + _.states[i] + '</option>');
            if (i == "MN") {
                option.attr("selected", "selected");
            }
            $("#user-profile-state").append(option);
        }
        $("#user-profile-state").val(registrant.state);
        $("#user-profile-zip").val(registrant.zip);
        $("#user-profile-phone").val(registrant.phone_number);
        $("#user-profile-email").val(registrant.email);
        $("#user-profile-bio").val(registrant.personal_bio);

        // Populate the select fields
        $("#user-profile-sms-notifications").val(registrant.receive_sms);
        $("#user-profile-email-notifications").val(registrant.receive_email);

        $("#user-profile-contact-preference")
            .populate_options(App_Models_Registrant.user_contact_preference_enum_select())
            .val(registrant.user_contact_preference);

        $("#ac-modal-user-profile-edit").modal_show();
    }

    static async try_save_user_settings() {

        let $form = $("#user-profile-edit-form");

        let profile_form_values = _.serialize_form($form);

        console.log(profile_form_values);

        try {
            let response = await _.backend_ajax('profile', 'save_profile', profile_form_values);

            if (response.requires_phone_validation) {
                // Phone validation workflow
                _.User_Profile_Modal.profile_edit_sms_verify_modal(
                    profile_form_values, response.the_phone_number, 'profile', 'save_profile', async function () {
                        _.flash_alert("Profile saved!", "success")
                        // await _.data_sync();
                        await _.Modal.hide();
                        _.User_Profile_Modal.show_settings_modal();
                    }
                );
            } else {
                _.flash_alert("Profile saved!", "success")
                // await _.data_sync();
                await _.Modal.hide();
                _.User_Profile_Modal.show_settings_modal();
            }

        } catch (error) {
            // Server side validation / general error, show error and keep modal open
            await _.Modal.form_reopen_error(error);
        }

        // Todo: handle change phone number request via notification
    }

    static async change_user_password() {

        let password_1 = $('<div class="input-group-ac input-group-password-modal reset_password_1" style="padding-bottom:20px;"><input type="password" class="form-control" name="password_1" /></div>');
        let password_2 = $('<div class="input-group-ac input-group-password-modal reset_password_2" style="padding-bottom:20px;"><input type="password" class="form-control" name="password_2" /></div>');

        const fields = {
            "New Password": password_1,
            "New Password Again": password_2
        };

        // Setup modal form options
        const options = {
            title: 'Change Password',
            body: 'Please enter your new password:',
            fields: fields,
            body_width: 400,
            hide_on_submit: false,
            submitCaption: 'Change Password',
            cancelCaption: 'Cancel',
            validate: function (data) {
                let errors = {};
                if (!data.password_1) {
                    errors.password_1 = 'Please enter the password.';
                }
                if (data.password_1 != data.password_2) {
                    errors.password_2 = 'The passwords must match.';
                }
                return $.isEmptyObject(errors) ? true : errors;
            }
        };

        await _.Modal.form(options, async function (result) {

            let data = {
                password: result.password_1
            };

            let response = await _.backend_ajax('profile', 'save_profile', data);

            if (response.requires_phone_validation) {
                // Phone validation workflow
                _.User_Profile_Modal.profile_edit_sms_verify_modal(
                    data, response.the_phone_number, 'profile', 'save_profile', async function () {
                        _.flash_alert("Password updated!", "success")
                        _.User_Profile_Modal.show_settings_modal();
                    }
                );
            } else {
                _.shouldnt_happen();
                return;
            }
        });
    }

    // Displays the login sms verification modal, used after the login via SMS modal.
    static profile_edit_sms_verify_modal(the_request, the_phone_number, ajax_argument_1, ajax_argument_2, callback_on_success) {

        let form_selector = "#ac-modal-update-profile-sms-verify-form";
        let $form = $(form_selector);

        $("#ac-modal-update-profile-sms-verify").modal_show();
        $("#ac-modal-update-profile-sms-first-digit").focus();

        _.reset_form_errors($form);
        _.reset_form_values($form);

        $("#ac-modal-update-profile-sms-verify-thephone").text(_.formatPhoneNumber(the_phone_number));

        // Submit button
        $form.off('submit').on('submit', function (e) {
            e.preventDefault();

            (async function () {
                let data = the_request;
                data.phone_verify = $form.find('.thedigits').val();

                _.reset_form_errors($form);

                try {
                    let response = await _.backend_ajax(ajax_argument_1, ajax_argument_2, data, $form);
                    await _.Modal.hide();
                    callback_on_success();

                } catch (error) {
                    _.apply_form_errors($form, error);
                    _.reset_form_values($form);
                    $("#ac-modal-update-profile-sms-first-digit").focus();
                }
            }());
        });
    }

}